import LS from "../../utils/localStorageUtils";
import { isTokenExpired } from "../../utils/helpers/tokenUtils";
import { UserProfile, UserStatistics } from "../../store/types";
import { AuthState } from "../../store/auth/authReducer";

export function loadAuthFromStorage(): Partial<AuthState> {
  const token = LS.get("access_token") || undefined;

  const validToken = token && !isTokenExpired(token) ? token : undefined;

  let user: UserProfile | undefined;
  const u = LS.get("auth_user");
  if (u) {
    try {
      user = JSON.parse(u) as UserProfile;
    } catch {}
  }

  return {
    token: validToken,
    isLogged: Boolean(validToken),
    user: validToken ? user : undefined,
    loading: false,
    error: undefined,
    // statistics: null,
  };
}
